<mf-page title="Editar cliente">
  @if (clientDto) {
  <mf-client
    [clientDto]="clientDto"
    (save)="save($event)" />
  }
</mf-page>
